import React, {useEffect, useMemo, useState} from 'react'
import Video from '../../../eyeson/video'
import axios from "axios";
import {useDispatch, useSelector} from "react-redux";
import {useBeforeunload} from "react-beforeunload";
import {groupChatSetAccessToken} from "../../exhibition_actions";
import useTranslation from "../../effects/use_translation";
import { v4 as uuidv4 } from 'uuid';

const GroupChat = ({videoConferenceIdentifier}) => {
  const dispatch = useDispatch()
  const accessToken = useSelector(state => state.groupChat?.access_token)
  const isBoothEditor = useSelector(state => state.isBoothEditor)
  const translation = useTranslation("translations.en")
  const [videoConferenceInfo, setVideoConferenceInfo] = useState()
  const sessionId = useMemo(() => uuidv4(), [])
  const groupChatInfoUrl = decodeURIComponent(useSelector(state => state.groupChat?.infoUrl)).replaceAll("@@video_conference_identifier@@", videoConferenceIdentifier)
  const groupChatJoinUrl = decodeURIComponent(useSelector(state => state.groupChat?.joinUrl))
    .replaceAll("@@video_conference_identifier@@", videoConferenceIdentifier)
    .replaceAll("@@session_id@@", sessionId || "not_set")
  const groupChatQuitUrl = decodeURIComponent(useSelector(state => state.groupChat?.quitUrl))
    .replaceAll("@@video_conference_identifier@@", videoConferenceIdentifier)
    .replaceAll("@@session_id@@", sessionId || "not_set")

  if (isBoothEditor) {
    return <div>
      Group Chat
    </div>
  }

  useEffect(() => {
    if (!accessToken) {
      axios.post(groupChatJoinUrl)
        .then(response => {
          dispatch(groupChatSetAccessToken(response.data.access_token))
        }).catch(error => {
        console.error("error", error?.response?.data)
        alert(error?.response?.data?.message || "Error")
      })
    } else {
      console.log("Token set")
    }
  }, [accessToken]);

  useEffect(() => {
    return () => {
      dispatch(groupChatSetAccessToken(null))
    }
  }, [])

  useEffect(() => {
    axios.get(groupChatInfoUrl)
      .then(response => {
        setVideoConferenceInfo(response.data.video_conference)
      }).catch(error => {
      console.error("error", error?.response?.data)
      alert(error?.response?.data?.message || "Error")
    })
  }, []);

  useEffect(() => {
    return () => {
      axios.post(groupChatQuitUrl)
    };
  }, []);

  const beforeunloadHook = () => {
    if (!navigator.sendBeacon) return true;

    const headers = {type: 'application/json'};
    const blob = new Blob([JSON.stringify({})], headers);
    navigator.sendBeacon(groupChatQuitUrl, blob);
  }

  useBeforeunload(beforeunloadHook)

  if (accessToken) {
    return <Video key={accessToken} settings={videoConferenceInfo} videoConferenceIdentifier={videoConferenceIdentifier} accessKey={accessToken} additionalVideoClass={"embed-responsive-item"}/>
  }

  return <>
    {translation(`group_chat.joining`)}
  </>
}

export default GroupChat